// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__MvlwU"};